module.exports = __webpack_public_path__ + "media/baowen.aca2f34d.mp4";